// Dark-surface decision panel used on gate-review pages.

import { useState } from 'react';

export function GateDecisionPanel({
  onApprove,
  onRequestRevision,
  onDefer,
  onReject,
  disabled = false,
  recommendation,
}) {
  const [rationale, setRationale] = useState('');
  const run = (fn) => () => fn && fn(rationale);
  return (
    <section className="gate-decision-panel" aria-label="Executive decision panel">
      <header>
        <div className="eyebrow" style={{ color: 'rgba(255,255,255,0.7)' }}>
          Executive decision
        </div>
        <h3>Record the gate decision</h3>
        {recommendation ? <p className="gate-recommendation">{recommendation}</p> : null}
      </header>
      <label className="gate-rationale-label">
        Decision rationale
        <textarea
          rows={3}
          value={rationale}
          onChange={(e) => setRationale(e.target.value)}
          placeholder="Capture the rationale that justifies this decision. Logged to audit."
        />
      </label>
      <footer className="gate-decision-actions">
        <button className="btn success tactile-press" onClick={run(onApprove)} disabled={disabled}>
          Approve
        </button>
        <button
          className="btn tonal tactile-press"
          onClick={run(onRequestRevision)}
          disabled={disabled}
        >
          Request revision
        </button>
        <button className="btn ghost tactile-press" onClick={run(onDefer)} disabled={disabled}>
          Defer
        </button>
        <button className="btn danger tactile-press" onClick={run(onReject)} disabled={disabled}>
          Reject
        </button>
      </footer>
      <p className="gate-decision-note">
        Decisions create audit events. AI may draft a brief, but only a human authorises the gate.
      </p>
    </section>
  );
}
